package ai.jessie.web.pages.organisations

import ai.jessie.web.documents.DOCUMENTS_TITLE
import ai.jessie.web.documents.DocumentFilter
import ai.jessie.web.documents.DocumentState
import ai.jessie.web.documents.LocalDocumentPort
import ai.jessie.web.documents.documentInbox
import ai.jessie.web.documents.documentsHref
import ai.jessie.web.onboarding.OnboardingProblem
import ai.jessie.web.onboarding.onboardingProblem
import ai.jessie.web.onboarding.organisationRequiredProblem
import ai.jessie.web.onboarding.validOrganisationId
import ai.jessie.web.theme.AlertStyle
import ai.jessie.web.theme.appFrame
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.key
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.isExporting
import com.varabyte.kobweb.silk.style.toAttrs
import org.jetbrains.compose.web.dom.Div

// UC-017 and UC-020 B8. Tenant state is keyed by the routed organisation, document and state
// filter, so a change of any discards it together with any unconfirmed selection or edit.
@Page("{organisationId}/documents")
@Composable
fun organisationDocumentsPage(ctx: PageContext) {
    val organisationId = ctx.route.dynamicParams["organisationId"].orEmpty()
    val filter = DocumentFilter.of(ctx.route.params["status"])
    if (!validOrganisationId(organisationId)) {
        documentProblemFrame(organisationId, organisationRequiredProblem())
    } else key(organisationId, filter) { documentsContent(organisationId, null, filter) }
}

/** The documents frame around a problem that needs no request, e.g. an invalid link. */
@Composable
internal fun documentProblemFrame(organisationId: String, problem: OnboardingProblem) {
    appFrame(organisationId, documentsHref(organisationId), DOCUMENTS_TITLE, subtitle = INBOX) {
        Div(attrs = AlertStyle.toAttrs()) { onboardingProblem(problem, busy = false) }
    }
}

// An invalid document ID sends no detail request and shows the neutral absence beside the list.
// The top bar marks "Dokumente" for every state; the title never changes.
@Composable
internal fun documentsContent(
    organisationId: String,
    documentId: String?,
    filter: DocumentFilter,
) {
    val port = LocalDocumentPort.current
    val scope = rememberCoroutineScope()
    val model =
        remember(port, scope, organisationId, filter) {
            DocumentState(port, scope, organisationId, filter)
        }
    LaunchedEffect(model) { if (!AppGlobals.isExporting) model.refresh() }
    appFrame(
        organisationId,
        documentsHref(organisationId),
        DOCUMENTS_TITLE,
        subtitle = filter.label,
        authenticationRequired = model.state.error?.authenticationRequired == true,
    ) {
        documentInbox(organisationId, documentId, filter, model.state, model.actions, model::lost)
    }
}

private const val INBOX = "Inbox"
